<template>
  <div class="whd-brochure-create">
    <div class="whd-brochure-head whd-tright">
      <div class="weui-cell">
        <div class="weui-cell__bd">
          <div class="title">
            <i class="goback el-icon-arrow-left" @click="goback"></i>
            {{titleInfo}}
          </div>          
        </div>
        <div class="weui-cell__ft">
          <el-button type="primary" @click="onSave">保存</el-button>
        </div>
      </div>
    </div>
    <!-- 轮播图 -->
    <div class="whd-brochure-carousel">
      <div class="weui-cell" id="carousel">
        <div class="weui-cell__bd">
          <div class="box whd-tcenter whd-gray999" :style="{width: width, height: height, lineHeight: height, backgroundImage: 'url('+ form.back_img +')'}">
            <template v-if="form.pages.length>0">
              <el-carousel ref="elCarousel" trigger="click" :autoplay="false" @change="onChangeCarousel">
                <el-carousel-item v-for="(item,index) in form.pages" :key="index">
                  <div class="weui-cell"> 
                    <div class="weui-cell__bd">
                      <img v-if="item.page_img" :src="item.page_img" />
                      <p v-else class="noticeP">本页无图片</p>
                      <div class="weui-cell abs" v-if="item.jump_type != 0">
                        <div class="weui-cell__bd">
                          <el-button v-if="item.jump_type==1 && item.button_text" class="btn" type="primary" size="small">{{item.button_text}}</el-button>
                          <div class="whd-tleft" v-if="item.jump_type == 2">
                            <p class="font16 whd-ellipsis" v-if="item.item_name">{{item.item_name}}</p>
                            <p class="font14" v-if="item.item_price">&yen;{{item.item_price}}</p>
                          </div>
                        </div>
                        <div class="weui-cell__ft ml-10" v-if="item.jump_type == 2 && item.button_text">
                          <el-button type="primary" size="small">{{item.button_text}}</el-button>
                        </div>
                      </div>
                    </div>
                  </div>
                </el-carousel-item>
              </el-carousel>
              <div class="slide-dot">{{selectIdx + 1}} / {{form.pages.length}}</div>
            </template>
            <template v-else>右侧添加页面</template>
          </div>
        </div>
      </div>
    </div>
    <!-- 设置面板 -->
    <div class="whd-brochure-set" id="brochureSet">
      <el-form ref="form" :model="form" label-width="70px" style="padding-left: 25px; padding-right: 25px;">
        <el-form-item label="手册名称">
          <el-input v-model="form.title" maxlength="30" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="手册简介">
          <el-input v-model="form.introduction" maxlength="30" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="手册背景">
          <el-radio-group v-model="radioBgpic" @change="onSwitchRadio">
            <el-radio :label="0">使用默认背景</el-radio>
            <el-radio :label="1">自定义背景</el-radio>
          </el-radio-group>  
          <div class="imglist" v-if="radioBgpic==0">
            <div class="imgbox" :class="{act:bgIndex==index}" v-for="(item,index) in bglist" :key="index" @click="onSelectBgpic(index)"><img :src="item.url" /></div>
          </div>    
          <div class="addicon addicon1 mt-10" v-else>
            <div v-if="form.back_img" class="imgbox">
              <img :src="form.back_img" />
              <div class="abs">
                <i class="el-icon-zoom-in" @click="previewImage(0)"></i>
                <i class="el-icon-delete" @click="form.back_img=''"></i>
              </div>
            </div>
            <div v-else class="el-upload el-upload--text" @click="onOpenCorpper(0)">
              <i class="el-icon-plus avatar-uploader-icon"></i>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="封面图">
          <div class="addicon addicon2">
            <div v-if="form.cover" class="imgbox">
              <img :src="form.cover" />
              <div class="abs">
                <i class="el-icon-zoom-in" @click="previewImage(1)"></i>
                <i class="el-icon-delete" @click="form.cover=''"></i>
              </div>
            </div>
            <div v-else class="el-upload el-upload--text" @click="onOpenCorpper(1)">
              <i class="el-icon-plus avatar-uploader-icon"></i>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="手册内容">
           <el-button type="success" plain @click="dialogVisiblePage=true">导入内容</el-button>
           <!-- <el-button type="text">操作说明</el-button> -->
        </el-form-item>        
      </el-form>
      <div class="panels">
        <p class="whd-tright noticeP" style="padding: 10px 20px;">（最多可添加100张图片，拖动可调整图片顺序）</p>
        <div v-if="form.pages.length>0">
          <draggable v-model="form.pages" tag="ul" class="draggable-body-list" animation="100" style="padding: 15px 25px 0;">
            <transition-group class="draggable-body">
              <li :id="'page'+index" v-for="(item,index) in form.pages" :key="index" class="addepage" :class="{on:selectIdx==index}" @click="onChange(index)" @mouseenter="onHover(index)">
                <div class="weui-cell">
                  <div class="weui-cell__hd">
                    <el-upload
                      class="addicon addicon3"
                      ref="imgupload"
                      :data="uploaddata"
                      :action="uploadurl"
                      :show-file-list="false"
                      accept="image/jpeg,image/png"
                      :on-success="handleSuccess"
                      :on-error="handleError"
                      :before-upload="beforeUpload">
                        <div v-if="item.page_img" class="imgbox">
                          <img :src="item.page_img" @load="onGetImgInfo($event,item.page_img,index)" />
                          <div class="abs">
                            <i class="el-icon-zoom-in" @click.stop="previewImage(2,index)"></i>
                            <i class="el-icon-delete" @click.stop="onClickDel(index)"></i>
                          </div>
                        </div>
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>  
                    <div class="noticeP whd-tcenter" v-if="item.img_width && item.img_height">{{item.img_width}} x {{item.img_height}}</div>  
                  </div>
                  <div class="weui-cell__bd">
                    <el-form ref="form" :model="item" label-width="100px">
                      <el-form-item label="页面名称：" class="elform">
                        <el-input class="w200" v-model="item.page_name" maxlength="8" show-word-limit></el-input>
                      </el-form-item>    
                      <el-form-item label="页面跳转：" class="elform">
                        <span class="whd-gray666" v-if="item.jump_type==0">不跳转</span>
                        <span class="whd-gray666" v-else>{{item.item_name}}</span>
                        <el-dropdown class="ml-10" @command="handleCommand">
                          <span class="el-dropdown-link required whd-hand">
                            修改<i class="el-icon-arrow-down el-icon--right"></i>
                          </span>
                          <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="2">商品</el-dropdown-item>
                            <el-dropdown-item command="1">表单</el-dropdown-item>
                            <el-dropdown-item command="0">不跳转</el-dropdown-item>
                          </el-dropdown-menu>
                        </el-dropdown>          
                      </el-form-item>   
                      <el-form-item label="按钮文案：" class="elform mb0" v-if="item.jump_type!=0">
                        <el-input class="w200" v-model="item.button_text" maxlength="8" show-word-limit></el-input>
                      </el-form-item>                   
                    </el-form>  
                  </div>
                </div>
                <i class="el-icon-error" @click.stop="onDelPage(index)"></i>
              </li>
            </transition-group>
          </draggable> 
        </div> 
        <div v-if="form.pages.length<100" class="weui-cell whd-tcenter addepage" style="height: 144px; margin-left: 25px; margin-right: 25px;">
          <div class="weui-cell__bd">
            <el-button type="primary" icon="el-icon-circle-plus" @click="onAddPage">添加页面</el-button>
            <p class="noticeP mt-10">手册所有页面建议统一尺寸：600*900</p>
          </div>
        </div> 
      </div>   
    </div>
    <corpper :visible.sync="corppervisible" v-if="corppervisible" @imgAddBack="imgAddBack" :imgSize="imgSize"></corpper>
    <addPageDialog :visible.sync="dialogVisiblePage" :id="id" :len="form.pages.length" :limit="100 - form.pages.length" @uploadsucess="uploadsucess"></addPageDialog>       
    <brochureDetailDialog :visible.sync="dialogTableVisible" :page="pageDialog" :type="tableType" :property="tableData" :formdata="tableType==0?goodObj:formObj"
      @onGoodsOrForm="onGoodsOrForm" @loadMoreGoodsOrForm="loadMoreGoodsOrForm" @updatePageInfo="updatePageInfo"></brochureDetailDialog>        

    <el-dialog :visible.sync="dialogVisible" :title="dialogTitle" width="600px">
      <img :src="dialogImageUrl" alt="" width="100%">
    </el-dialog>       
  </div>    
</template>

<script>
import corpper from "@/components/dialog/corpper.vue";
import addPageDialog from "@/components/dialog/addPageDialog.vue";
import addPageBrochure from "@/components/dialog/addPageBrochure.vue";
import brochureDetailDialog from "@/components/dialog/brochureDetailDialog.vue";
import draggable from 'vuedraggable';
import { pagination } from "@/util/util.js";
import api from "@/api.js";
export default {
  name: "addOrEditBrochure",
  components: {
    corpper,
    draggable,
    addPageDialog,
    addPageBrochure,
    brochureDetailDialog
  },
  data() {
    return {
      width: 375,             // 左侧默认宽度
      height: 750,            // 左侧默认高度
      imgSize: 12,            // 图片尺寸类型
      radioBgpic: 0,          // 选择默认背景图或自定义
      bgIndex: 0,             // 选择当前默认背景图
      bglist: [],             // 默认背景图列表
      corpperNum: 0,          // 图片裁剪
      corppervisible: false,  // 是否显示图片裁剪框
      carousel: [],           // 左侧轮播列表
      dialogVisible: false,   // 是否显示图片预览框
      dialogImageUrl: "",     // 图片预览路径
      dialogTitle: "",
      dialogVisiblePage: false,
      selectIdx: 0,
      titleInfo: "添加宣传册",
      isAddPage: false,
      form: {                 // 页面数据
        title: "",
        introduction: "",
        back_id: 0,
        back_img: "",
        cover: "",
        pages: []
      },
      dialogTableVisible: false,
      pageDialog: {
        pageindex: pagination.pageIndex,
        pagesize: pagination.pageSize,
        total: pagination.total
      },  
      tableType: 0,
      tableData: [],
      goodObj: {
        check_type: 1,    // 筛选类型(0全部、1已上架、2已售罄、3未上架)
        goods_type: 0,    // 商品类型(0全部、1实体商品-仅线上展示、2实体商品-支持线上支付、3虚拟商品
        name: "",         // 商品名称
        cat_id: ""        // 分类id
      },
      formObj: {
        title: "",        // 表单名称
        status: 1         // 查看状态(0全部、1已启用、2未启用)
      },
      uploadurl: api.uploadTokenImg,
      uploaddata: {token: sessionStorage.getItem("token")},
      currentIndex: 0
    }
  },  
  computed: {
    elCarousel() {
      return this.$refs.elCarousel;
    }
  },
  watch: {
    'form.pages': {
      immediate: true,
      handler(val) {
        let obj = val;
        this.form.pages = obj;
        let idx = this.selectIdx;
        if (val.length > 0) {
          this.getImgInfo(val[0].page_img);
          this.selectIdx = idx; 
        } 
      }
    },
    selectIdx(newVal, oldVal) {
      if (this.isAddPage) {
        this.isAddPage = false;
        document.getElementById("page"+oldVal).click();
      } else {
        if (newVal != oldVal) {
          let top = document.getElementById("page"+newVal).offsetTop;
          document.getElementById("brochureSet").scrollTo({
            top: top - 15,
            behavior: "smooth"
          });
        };
      };
    }  
  },
  created() {
    this.type = this.$route.query.type || "";
    this.id = this.$route.query.id || "";
    this.axios
      .post(api.brochure_background_list, {})
      .then(response => {
        if (response.data.code == 0) {
          this.bglist = response.data.list;
          if (!this.id) {
            this.form.back_id = this.bglist[0].id;
            this.form.back_img = this.bglist[0].url;
          }
        } else {
        }
      })
      .catch(() => {});    
    if (this.id) {
      // 编辑
      this.titleInfo = "修改宣传册";
      this.getDetail();
    }
  },
  mounted() {
    // 计算高度
    this.$nextTick(function() {
      this.onGetWH(0);
      window.onresize = () => { 
        this.onGetWH(this.type);
      };
    })
  },
  methods: {
    onGetImgInfo(e,src,index) {
      var img = new Image();
      img.src = src;
      this.form.pages[index].img_width = img.width;
      this.form.pages[index].img_height = img.height;
    },
    onHover(index) {
      this.currentIndex = index;
    },
    onClickDel(index) {
      this.form.pages[index].page_img = "";
    },
    handleCommand(command) {
      this.form.pages[this.currentIndex].jump_type = command;
      this.onGoodsOrForm({type: command, index: this.currentIndex})
    }, 
    handleError(err, file) {
      this.$message({
        type: "error",
        message: "上传失败"
      });
    },
    beforeUpload(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 10;
      let status = true;
      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG或者PNG 格式!");
        status = false;
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 10MB!");
        status = false;
      }
      if(status){
        this.loadingStatus = this.$loading({
          lock: true,
          text: '上传中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.4)',
          customClass: 'fontColor'
        });
      }
      return isJPG && isLt2M;
    },
    handleSuccess(res, file) {
      if (res.code === 0) {
        this.form.pages[this.currentIndex].page_img = res.path;
      } else {
        this.$message.error(res.msg);
      }
      this.loadingStatus.close();
    },     
    goback() {
      this.$router.go(-1);
    },
    // 关联商品、表单
    initGoodsOrForm(num,type) {
      let tableObj;
      if (type == 2) {  // type 0-选择已上架商品 1-选择表单 
        tableObj = this.goodObj;
      } else {
        tableObj = this.formObj;
      }
      tableObj.page = this.pageDialog.pageindex;
      this.axios   
        .post(type==2?api.goods_index:api.companyadmin_form_list, tableObj)
        .then(response => {
          if (response.data.code == 0) {
            this.tableData = response.data.list;
            this.pageDialog.total = response.data.all_page;
            if (num == 0) {
              this.dialogTableVisible = true;
            }
          }
        })
        .catch(() => {});      
    },    
    // 加载更多数据
    loadMoreGoodsOrForm(e) {
      this.pageDialog.pageindex = e.pageindex;
      if (e.type == 2) {
        this.goodObj = e.obj;
      } else {
        this.formObj = e.obj;
      }
      this.initGoodsOrForm(1,e.type);
    },
    // 接收商品列表或表单列表子组件数据
    onGoodsOrForm(e) {
      this.tableType = e.type;
      this.editIndex = e.index;
      if (e.type != 0) {
        this.initGoodsOrForm(0,e.type);
      }
    },
    // 接收导入内容子组件数据
    uploadsucess(e) {
      if (Array.isArray(e)) {
        this.form.pages = [...this.form.pages, ...e];
      } else {
        this.form.pages.push(e);
      }
    },
    // 更新当前页面数据
    updatePageInfo(e) {
      this.form.pages[this.editIndex].item_id = e.obj.id;
      this.form.pages[this.editIndex].item_name = e.obj.title;     
      if (e.type == 2) {
        this.form.pages[this.editIndex].item_price = e.obj.price;
        this.form.pages[this.editIndex].item_img = e.obj.img;
      } else {
        this.form.pages[this.editIndex].item_price = "";
        this.form.pages[this.editIndex].item_img = "";
      }  
      this.$set(this.form.pages, this.editIndex, this.form.pages[this.editIndex]);
    },
    // 轮播图切换
    onChangeCarousel(e) {
      this.selectIdx = e;
    },
    onChange(e) {
      this.selectIdx = e;
      this.elCarousel.setActiveItem(e);
      let top = document.getElementById("page"+e).offsetTop;
      document.getElementById("brochureSet").scrollTo({
        top: top - 15,
        behavior: "smooth"
      });
    },
    // 添加页面
    onAddPage() {
      let obj;
      if (this.id) {
        obj = {
          page_id: 0,
          jump_type: 0,
          item_id: "",
          item_name: "",
          item_price: "",
          item_img: "",
          page_name: "页面" + (this.form.pages.length + 1),
          page_img: "",
          button_text: ""
        }
      } else {
        obj = {
          jump_type: 0,
          item_id: "",
          item_name: "",
          item_price: "",
          item_img: "",
          page_name: "页面" + (this.form.pages.length + 1),
          page_img: "",
          button_text: ""
        }
      }
      this.form.pages.push(obj);
    },
    // 获取图片宽高
    getImgInfo(imgUrl) {
      let that = this;
      let img = new Image();
      img.src = imgUrl;
      img.onload = function () {
        if (img.width > img.height) {
          that.type = 1;
          that.onGetWH(1);
        } else {
          that.type = 0;
          that.onGetWH(0);
        } 
      }
    }, 
    // 宣传册详情
    getDetail() {
      this.axios
        .post(api.brochure_detail, {brochure_id: this.id})
        .then(response => {
          if (response.data.code == 0) {
            this.form = response.data.info;
            if (this.form.back_id === 0) {
              this.radioBgpic = 1;
            } else {
              this.radioBgpic = 0;
              this.bgIndex = this.form.back_id - 1;
            }
          } else {
          }
        })
        .catch(() => {});
    },
    // 计算左侧背景宽高 num 0-竖屏 1-横屏
    onGetWH(num) {
      let w = document.getElementById("carousel").offsetWidth;
      let h = document.getElementById("carousel").offsetHeight;
      let ratio = w / h;
      if (w / h > 1) {
        ratio = h / w;
      }
      if (num == 0) {
        this.width = ratio * 375 + 'px';
        this.height = ratio * 750 + 'px';
      } else {
        this.width = ratio * 750 + 'px';
        this.height = ratio * 375 + 'px';
      };
    },
    // 选择默认背景
    onSelectBgpic(index) {
      this.bgIndex = index;
      this.form.back_id = this.bglist[index].id;
      this.form.back_img = this.bglist[index].url;
    },
    // 切换默认、自定义背景
    onSwitchRadio(option) {
      if (option == 1) {
        this.form.back_id = 0;
        this.form.back_img = "";
      } else {
        this.form.back_id = this.bglist[this.bgIndex].id;
        this.form.back_img = this.bglist[this.bgIndex].url;
      };
  
    },  
    // 图片预览
    previewImage(option,num) {
      if (option === 0) {
        this.dialogImageUrl = this.form.back_img;     
        this.dialogTitle = "背景图预览";
      } else if (option === 1) {
        this.dialogImageUrl = this.form.cover;
        this.dialogTitle = "封面图预览";
      } else {
        this.dialogImageUrl = this.form.pages[num].page_img;
        this.dialogTitle = this.form.pages[num].page_name;
      }
      this.dialogVisible = true;
    },  
    // 上传图片
    onOpenCorpper(option) {
      this.corpperNum = option;
      if (option == 0) {
        this.imgSize = 12;
      } else {
        this.imgSize = 13;
      } 
      this.corppervisible = true;
    },
    // 上传图片成功回调
    imgAddBack(option) {
      // corpperNum 0-自定义背景 1-自定义封面图 
      if (this.corpperNum == 0) {
        this.form.back_img = option;
      } else {
        this.form.cover = option;
      } 
    },
    draggEndSort(e) {
      let oldItem = this.form.pages[e.oldIndex];
      let newItem = this.form.pages[e.newIndex];
      let list = this.form.pages;
      list[e.oldIndex] = oldItem;
      list[e.newIndex] = newItem;
      this.form.pages = list;
      this.$set(this.form.pages, e.oldIndex, oldItem);
      this.$set(this.form.pages, e.newIndex, newItem);  
    },
    onDelPage(index) {
      let item = this.form.pages[index];
      this.$confirm('确认删除该页面?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (item.page_id && item.page_id != 0) {
          this.axios
            .post(api.brochure_pagedel, {page_id: item.page_id})
            .then(response => {
              if (response.data.code == 0) {
                  this.form.pages.splice(index,1);
                  if (index > 0 && this.selectIdx == index) {
                    this.form.pages[parseInt(index) - 1].click();
                  }
              } else {
              }
            })
            .catch(() => {});            
        } else {
          this.form.pages.splice(index,1);
        }      
      }).catch(() => {
           
      });      
    },
    // 保存
    async onSave() {
      if(!this.form.title.trim()) {
        this.$message.warning("请填写手册名称");
      } else if(!this.form.introduction.trim()) {
        this.$message.warning("请填写手册简介");
      } else if(!this.form.cover) {
        this.$message.warning("请上传封面图");
      } else if (this.form.pages.length < 1) {
        this.$message.warning("请添加页面");
      } else {
        let num = 0;
        await this.form.pages.forEach((item,index) => {
          if (!item.page_img) {
            this.$message.warning("请添加页面图片");
            this.selectIdx = index;
            this.elCarousel.setActiveItem(index);
            num = num + 1;
            return false;
          }
        });
     
        if (num == 0) {
          let url = "";
          let obj = {
            title: this.form.title,
            introduction: this.form.introduction,
            back_id: this.form.back_id,
            back_img: this.form.back_img,
            cover: this.form.cover,
            pages: JSON.stringify(this.form.pages) 
          };

          if (this.id) {
            url = api.brochure_edit;
            obj.brochure_id = this.id;
          } else {
            url = api.brochure_add;
          }
  
          this.axios
            .post(url, obj)
            .then(response => {
              if (response.data.code == 0) {
                this.$message.success(response.data.msg);
                if (!this.id) {
                  this.goback();
                }
              } 
            })
            .catch(() => {});   
        }    
      }
    }
  }
}
</script>

<style type="text/css" scoped>
.main_brochure{overflow: hidden;}
.addepage{position: relative;}
.addepage .elform{margin-bottom: 5px;}
.addepage .addicon3 .avatar-uploader-icon, .addepage .addicon3 .imgbox{margin-top: 0;}
.addepage .weui-cell{padding: 15px; -webkit-box-align: start; -ms-flex-align: start; align-items: start;}
</style>